export default __webpack_public_path__ + "static/media/bw_arrow_back.81a21f9a.svg";